export type ReservationType = {
  value?: number
  date?: string
}

export default function reservationDays(
  maxDays: number,
  currentReservationLength: number
): ReservationType[] {
  if (currentReservationLength > maxDays) return []

  const daysNumber = maxDays - currentReservationLength

  const arrayOfAvailableDays = []
  for (let i = 1; i <= daysNumber; i++) {
    arrayOfAvailableDays.push(i)
  }

  const reservations: ReservationType[] = arrayOfAvailableDays.reduce((acc, previous) => {
    let newValue: ReservationType = {}

    const today = new Date()
    var nextDay = new Date(today)
    nextDay.setDate(today.getDate() + previous + currentReservationLength)

    newValue.value = previous
    newValue.date = `${previous} dni (do ${nextDay.getDate()}.${
      nextDay.getMonth() + 1
    }.${nextDay.getFullYear()})`

    return [...acc, newValue]
  }, [] as ReservationType[])

  return reservations
}
